import { ADMIN_SIDEBAR_OPTIONS, MobileSidebar, MobileSubSidebarListItem, 
         MobileSubSidebarListItemWithSubMenu ,React, SIDEBAR_OPTIONS, Style, 
         useEffect, useQueryClient, useRouter, useState, useTranslation } from  '@/imports-files/components/sidebar';


export function MobileSubSidebar(props)
{
    const { t } = useTranslation();
    const router                                        =   useRouter();
    const OPTIONS                                       =   router.pathname.startsWith('/admins') ? ADMIN_SIDEBAR_OPTIONS[0] : SIDEBAR_OPTIONS(t)[0];
    const [subsidebar_options, setSubsidebarOptions]    =   useState(null);
    const [isLoading, setLoaderStatus]                  =   useState(true);
    const queryClient                                   =   useQueryClient();
    const key                                           =   queryClient.getQueryData('selectedNavOptions');
    const selected_sidebar_options                      =   queryClient.getQueryData('selectedSubSidebarOptions');
    const mobileSidebarAction                           =   new MobileSidebar(props.loadPageInDashboard, queryClient, props.setPageName); 
    
    useEffect(() => {
                        if(selected_sidebar_options!=undefined)
                        {   
                            const element = document.getElementById(key);
                            setSubsidebarOptions(OPTIONS[key]['subSidebar_options']);
                            mobileSidebarAction.activateSidebar(element);
                            mobileSidebarAction.activateSubsidebar(element, OPTIONS[key]);
                            let subsidebar_option = OPTIONS[key]['subSidebar_options'];
                            (subsidebar_option != null && OPTIONS[key]['subSidebar_options'][selected_sidebar_options] != null) ? mobileSidebarAction.subsidebarChangeIcon( OPTIONS[key]['subSidebar_options'][selected_sidebar_options]['step']):'';
                            setLoaderStatus(false);
                        }
                    })

    if(isLoading)
    {
        return <div>Loading</div>;
    }   

    return (   
                <div className={`SubSidebar ${Style.SubSidebar}`}>
                    
                    <div key='subSidebarList' className={`SubSidebar__List ${Style.SubSidebar__List}`}>
                        { OPTIONS[key]['type'] == "menu" ? <MobileSubSidebarListItemWithSubMenu loadPageInDashboard         =       {props.loadPageInDashboard} 
                                                                                                setPageName                 =       {props.setPageName} 
                                                                                                options                     =       {subsidebar_options} 
                                                                                                userRole                    =       {props.userRole}
                                                                                                setSubSubSidebarOptions     =       {props.setSubSubSidebarOptions}/>

                                                         : <MobileSubSidebarListItem   loadPageInDashboard         =   {props.loadPageInDashboard} 
                                                                                        setPageName                 =   {props.setPageName} 
                                                                                        options                     =   {subsidebar_options} 
                                                                                        userRole                    =   {props.userRole}
                                                                                        setSubSubSidebarOptions     =   {props.setSubSubSidebarOptions}/> }
                    </div>

                    <div key='topRightSection' className={Style.SubSidebar__TopRightCurveSection}>
                        <div className={Style.SubSidebar__TopRightCurve}></div>
                    </div>

                    <div key='bottomRightSection' className={Style.SubSidebar__BottomRightCurveSection}>
                        <div className={Style.SubSidebar__BottomRightCurve}></div>
                    </div>

                </div> 
            )
}